import React, { useState } from "react";
import "./styles.css";
import GoogleMapReact from "google-map-react";

export default function MapLocation(props) {
  let location = props.data;
  console.log("🚀 ~ file: index.js ~ line 7 ~ MapLocation ~ location", location)

  let locationData = {
    lat: parseFloat(location?.latitude ? location?.latitude : props.data?.lat),
    lng: parseFloat(
      location?.longitude ? location?.longitude : props.data?.lng
    ),
  };

  const renderMarkers = (map, maps) => {
    let marker = new maps.Marker({
      position: locationData,
      map,
      title: location?.location,
    });
    return marker;
  };

  return (
    <div style={{ height: "70vh", width: "100%" }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyA2xZCCiYZDrWyTw93aLyYsJ68cExy6784" }}
        defaultCenter={locationData}
        center={locationData}
        yesIWantToUseGoogleMapApiInternals
        defaultZoom={props.zoom}
        onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
      ></GoogleMapReact>
    </div>
  );
}
